module.exports = __webpack_public_path__ + "static/media/bbc_sport_live_football_35238092_plot.8e6481bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_sport_live_football_35238092_plot.png
// module id = 363
// module chunks = 0